import styled from '@emotion/styled';
import { LoadingButton } from '@mui/lab';
import {
  Box,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  InputLabel,
  Select,
} from '@mui/material';
import Button from '@mui/material/Button';
import FormControl from '@mui/material/FormControl';
import MenuItem from '@mui/material/MenuItem';
import useGetCoddingProfile from 'api/createListCodding/useGetCoddingProfile/useGetCoddingProfile';
import React, { useEffect, useState } from 'react';

const ChangeCodingProfileModal = ({ open, onClose, onConfirm, isLoading }) => {
  const [selectedCodding, setSelectedCodding] = useState(null);

  const [getAllCodding, allCoddingLoading, allCoddingFailed, allCoddingData] =
    useGetCoddingProfile();

  useEffect(() => {
    if (open) {
      getAllCodding('1');
    }
  }, [open]);

  return (
    <Dialog
      maxWidth="sm"
      fullWidth
      open={open}
      onClose={onClose}
      keepMounted={false}
      sx={{ direction: 'rtl' }}
    >
      <DialogTitle>تغییر پروفایل</DialogTitle>
      <DialogContent>
        <DialogContentText sx={{ paddingBottom: 3 }}>
          لطفا پروفایل کدینگ مورد نظر را انتخاب کنید.
        </DialogContentText>
        <FormControl fullWidth>
          <InputLabel id="selectedCodding">پروفایل کدینگ</InputLabel>
          <Select
            labelId="selectedCodding"
            id="selectedCodding"
            value={selectedCodding || null}
            name="selectedCodding"
            variant="outlined"
            label="پروفایل کدینگ"
            onChange={e => setSelectedCodding(e.target.value)}
          >
            {allCoddingData?.map(coddingType => (
              <MenuItem
                dense
                value={coddingType?.key}
                key={coddingType?.key}
                dir="rtl"
              >
                {coddingType?.value}
              </MenuItem>
            ))}
          </Select>
        </FormControl>
      </DialogContent>

      <DialogActions sx={{ gap: 1, padding: 3 }}>
        <Button
          onClick={onClose}
          variant="contained"
          color="warning"
          disabled={isLoading}
        >
          انصراف
        </Button>
        <LoadingButton
          variant="contained"
          onClick={() => onConfirm(selectedCodding)}
          loading={isLoading || allCoddingLoading}
          disabled={!selectedCodding || allCoddingLoading}
        >
          تایید
        </LoadingButton>
      </DialogActions>
    </Dialog>
  );
};
export default ChangeCodingProfileModal;

const FlexCenterBox = styled(Box)`
  display: flex;
  align-items: center;
  gap: 15px;
`;
